import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { alert, custom } from 'devextreme/ui/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

import notify from 'devextreme/ui/notify';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { RentriService } from '../../services/rentri.service';
import { Utenteservice } from '../../services/utente.service';
import { VivifirService } from '../../services/vivifir.service';
import { MessaggioComponent } from '../messaggio/messaggio.component';
import { NewNicaFormComponent } from '../nica-form/new-nica-form.component';

@Component({
  selector: 'app-vivifir',
  templateUrl: './vivifir.component.html',
  styleUrls: ['./vivifir.component.css']
})
export class VivifirComponent implements OnInit {
  @ViewChild('viviFirblocchi', { static: false }) viviFirblocchi: NewNicaFormComponent;
  @ViewChild('progressComponent', { static: false }) progressComponent: MessaggioComponent;
  @Input() codiceFiscale: any
  @Input() idSoggetto: any = undefined;
  @Input() idBlocco: any;
  @Input() isRentri: boolean = true;
  @Input() isSpurghi: boolean;
  @Input() isAnnullato: boolean;
  @Input() codiceBlocco: string;
  @Input() startSync: boolean = false;

  @Input() elencoBlocchiViviFir: any;
  @Output() emitViviFirdata: EventEmitter<any> = new EventEmitter<any>();

  datiGriglia: any;
  datijson: any = {}
  datiVivifir: {};
  showForm: boolean = false;
  mostraProgressPopup: boolean = false;
  progresso: number = 0;
  quantitaDaVidimare: number;
  messageView: string = '';

  constructor(

    public utenteService: Utenteservice,
    private viviFirService: VivifirService,
    private rentriService: RentriService,
    private loader: NgxSpinnerService,
    private anagraficaService: AnagraficaService,
    private apiService: Apiservice,
    private changeDetector?: ChangeDetectorRef
  ) { }


  ngOnInit() {

    // alert(this.codiceFiscale,'ok')

    if (this.idSoggetto) {



      if (typeof this.codiceFiscale != 'undefined' || typeof this.idSoggetto != 'undefined') {

        this.initialiezzed()

      }



    }


  }

  async initialiezzed() {
    //await this.loginViviFir();
    let res = await this.anagraficaService.getValue('VivifirBlocchi', this.idBlocco, '')
    const listaPosizioni = res['listaPosizioni']
    this.emitViviFirdata.emit(res)
    console.log('----------------------', listaPosizioni)
    if (Object.keys(res).length > 0) {
      this.datiVivifir = res;

      const api = this.isRentri ? 'RentriOld/GetElencoViviFir' : 'VivifirFormulari/GetNumVivifirLiberi'

      let queryString = this.isRentri ? `?IdSoggetto=${this.idSoggetto}&codice_blocco=${this.datiVivifir['blocco']}` : `?codicefiscale=${this.datiVivifir['codiceFiscale']}&blocco=${this.datiVivifir['blocco']}`

      //let numfirLiberi = await this.anagraficaService.getValue(api,'',queryString)
      //this.datiVivifir['numeroEFIR'] = 
      this.showForm = true
      if (this.datiGriglia) this.datiGriglia.refresh()
      if (this.viviFirblocchi) {
        this.viviFirblocchi.dynamicForm.get('ViviFirElencoFIRBlocchi').get('numfir').setValue('')
        this.viviFirblocchi.formRefreshGridDataSource()
      }
    }

    if (this.isAnnullato && this.viviFirblocchi !== undefined) {
      console.log('stampo vivifirblocchi', this.viviFirblocchi)
      // this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.blocco', 'disabled', true)
      // this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.descrizione', 'disabled', true)
      // this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.numeroFirLiberi', 'disabled', true)
      // this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.numeroFirOccupati', 'disabled', true)
      // this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.numeroFirMassimi', 'disabled', true)
      this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.numfir', 'disabled', true)
      this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.buttonGeneraFir', 'disabled', true)
      this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.elencoPosizioni', 'disabled', true)
      this.viviFirblocchi.itemOption('ViviFirElencoFIRBlocchi.sincronizzaFir', 'disabled', true)
    }
    this.changeDetector.detectChanges()

  }

  viviFirEvent(event) {
  }


  viviFirFormEventInitializzed(event) {
    // const elencoFormulari = event.formData.elencoFormulari
    // elencoFormulari.forEach(item => {
    //   if(item.stato !== 2) event.querySelector('.button-in-cell').style.visibility = 'hidden';
    // })
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['startSync']){
      if(this.startSync){
        this.formEventViviFir('sincronizzaFir')
      }
    }

    if (changes['idSoggetto'] || changes['idBlocco']) {
      this.initialiezzed();
    }
  }


  async allEvents(event) {
    if (event.dynamicComponent === "NicaAnagraficaComponent" && event.name === "onInitilized") {
      this.datiGriglia = event.masterComponent.griglia.instance
    }

    if (event.name === 'onRowPrepared') {
      if (event.data && event.data.stato !== 2) {
        event.rowElement.querySelector('.dx-command-edit').style.visibility = 'hidden';
      }
    }
    if (event.name == 'liberaFir') {

      let dataRow = { ...event.row.data }

      dataRow.stato = 1

      let api = 'VivifirFormulari'

      let res = await this.anagraficaService.actionPut(api, dataRow);

      if (res) {
        this.initialiezzed();

        event.component.refresh()
      }

    }
    //questa logica mi serve per associare le posizioni selezionate nella multiselect
    //prendendo in considerazione solo gli id
    if (event.name === "onRowMultipleSelectionChange" && event.accessoringData.dataField === "elencoPosizioni") {
      if (event.dataSelected.length > 0) {
        const posizioniSelezionate = event.dataSelected.filter((item) => item != undefined).map((item) => { return item.id });
        //recupero le informazioni del blocco
        let instanceData = {
          codiceFiscale: this.codiceFiscale,
          idSoggetto: this.idSoggetto,
          blocco: this.codiceBlocco,
          isSpurghi: this.isSpurghi,
          isAnnullato: this.isAnnullato,
          listaPosizioni: posizioniSelezionate
        }
        this.apiService.PutApi(`VivifirBlocchi/${this.idBlocco}`, instanceData).then((res) => {
          console.log('aooooooooooo', res)
        })
      }
    }
  }

  async formEventViviFir(event) {
    if (event.name === "sincronizzaFir" || event === "sincronizzaFir") {
      this.loader.show()
      try {
        this.apiService.GetApi(`VivifirFormulari/Sincronizza?codiceBlocco=${this.codiceBlocco}&idSoggetto=${this.idSoggetto}`).then((res) => {
          this.initialiezzed().then(() => {
            this.loader.hide()
            notify({
              message: `Sincronizzazione effettuata con successo`,
              height: 45,
              width: 250,
              position: 'center center'
            }, 'success', 6000);
          })
        })
      } catch (error) {
        this.loader.hide()
      }
    }
    //console.log('formEventViviFir',event)
    if (event.name == 'generaFirBlocco') {
      let nFir = event.data.numfir;
      if (!nFir || nFir == 0) {
        //alert('Genera solo 100 FIR per volta','Attenzione');
        return
      }
      if (nFir > 100) {
        alert('Genera solo 100 FIR per volta', 'Attenzione');
        return
      }
      let myDialog = custom({
        title: "Conferma vidimazione",
        messageHtml: `Sei sicuro di voler vidimare ${event.data.numfir} fir?`,

        buttons: [{
          text: "Conferma",
          icon: "web-rifiuti icon-check-1",
          elementAttr: {
            class: "vivifirClass",
          },

          onClick: (e) => {
            return { generateFir: true }
          }
        }, {
          text: "Annulla",
          icon: "glyphicon icon-annulla-form",
          elementAttr: {
            class: "vivifirClass"
          },
          onClick: (e) => {
            return { generateFir: false }
          }
        },
        ]
      });
      myDialog.show().then(async (dialogResult) => {
        if (dialogResult.generateFir) {
          if (dialogResult) {
            this.quantitaDaVidimare = Math.min(event.data.numfir, 100);
            this.progresso = 0;
            this.mostraProgressPopup = true;
            this.changeDetector.detectChanges();

            for (let i = 0; i < this.quantitaDaVidimare; i++) {
              try {
                const res: any = await this.generaFir(event.data.blocco, 1, event.data.isSpurghi)
                if (!res.result) break;
                this.progressComponent.aggiornaProgresso(this.progresso++)
              } catch (error) {
                return
              }
            }
            console.log(`${this.progresso} su ${this.quantitaDaVidimare}`)
            const typeMessage = this.progresso == this.quantitaDaVidimare ? 'success' : 'warning'
            const icon = this.progresso == this.quantitaDaVidimare ? 'icon-ok-circle' : 'icon-warning-circle'
            this.messageView = `Sono stati generati ${this.progresso} fir su ${this.quantitaDaVidimare}`
            this.progressComponent.showNotify(this.messageView, typeMessage, icon)
            this.mostraProgressPopup = false;
            this.initialiezzed()
          }
        } else { return }
      });
    }
  }

  statusFormat = (ratio: number, value: number): string => {
    const total = this.quantitaDaVidimare;
    return `Vidimati ${Math.round(value)} di ${total}`;
  };


  async viviFirDataGridEvent(event) {
    console.log(event)
    //alert(event,'annullaFir')

    if (event.name == 'annullaFir') {

      let dataRow = event.rowData

      dataRow.stato = 3

      let api = 'VivifirFormulari'

      let res = await this.anagraficaService.actionPut(api, dataRow);

      if (res) {
        event.component.refresh()
      }

    }
  }


  async generaFir(idBlocco: string, nfir: number, isSpurghi: boolean): Promise<void> {
    if (!idBlocco) return;

    try {
      let res;

      if (isSpurghi) {
        res = await this.viviFirService.generaFir(this.idSoggetto, idBlocco, nfir);
        if (res) {
          return res;
        }
      } else {
        res = await this.rentriService.generaFir(this.idSoggetto, idBlocco, nfir);
        if (res) {
          return res;
        }
      }
    } catch (error) {
      throw error;
    }
  }

  async loginViviFir() {

    await this.syncViviFir()

  }


  async syncViviFir() {

    try {

      let response = await this.viviFirService.syncBlocchi(this.idSoggetto);

      if (response) {

        //this.showBlocchiAzienda = true
      }

    } catch (ex) {


    } finally {

      await this.loader.hide();

    }
  }
}
